import { useIntl } from 'react-intl';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ProfilePageHeader } from '@sorare/core/src/components/navigation/ProfilePageHeader';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import { navLabels } from '@sorare/core/src/lib/glossary';

export const PlayPageHeader = () => {
  const { formatMessage } = useIntl();
  const {
    flags: { enableMyClubSplit = false },
  } = useFeatureFlags();

  return enableMyClubSplit ? (
    <ProfilePageHeader />
  ) : (
    <PageHeader text={formatMessage(navLabels.play)} disableBackBrowser />
  );
};
